import api from '../api/client';
// // components/ReceivablesAnalytics.js
// import React, { useState, useEffect } from "react";
// import { Row, Col, Card, Button, Spinner, Alert } from "react-bootstrap";
// import {
//   LineChart, BarChart, PieChart, Line, Bar, Pie, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer, Cell
// } from "recharts";

// const ReceivablesAnalytics = ({ dateRange, fetchData }) => {
//   const [metrics, setMetrics] = useState(null);
//   const [categoryData, setCategoryData] = useState([]);
//   const [trendData, setTrendData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FF6B6B'];

//   useEffect(() => {
//     loadAnalyticsData();
//   }, [dateRange]);

//   const loadAnalyticsData = async () => {
//     setLoading(true);
//     setError(null);
    
//     try {
//       // Fetch all analytics data in parallel
//       const [metricsRes, categoryRes, trendRes] = await Promise.all([
//         fetch(`/api/analytics/receivables-metrics?startDate=${dateRange.start}&endDate=${dateRange.end}`),
//         fetch(`/api/analytics/receivables-by-category?startDate=${dateRange.start}&endDate=${dateRange.end}`),
//         fetch(`/api/analytics/receivables-trend?startDate=${dateRange.start}&endDate=${dateRange.end}`)
//       ]);

//       if (!metricsRes.ok || !categoryRes.ok || !trendRes.ok) {
//         throw new Error('Failed to fetch analytics data');
//       }

//       const [metricsData, categoryData, trendData] = await Promise.all([
//         metricsRes.json(),
//         categoryRes.json(),
//         trendRes.json()
//       ]);

//       setMetrics(metricsData);
//       setCategoryData(categoryData);
//       setTrendData(trendData);
//     } catch (err) {
//       console.error("Error loading analytics:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading analytics data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <Alert variant="danger">
//         <Alert.Heading>Error Loading Analytics</Alert.Heading>
//         <p>{error}</p>
//         <Button variant="outline-danger" onClick={loadAnalyticsData}>
//           Retry
//         </Button>
//       </Alert>
//     );
//   }

//   if (!metrics || !categoryData.length || !trendData) {
//     return (
//       <div className="text-center py-4">
//         <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
//         <h5>No analytics data available</h5>
//         <p className="text-muted">No receivables data found for the selected period.</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Key Metrics Row */}
//       <Row className="mb-4">
//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-primary">
//                 <i className="fas fa-receipt me-2"></i>
//                 Total Receivables
//               </Card.Title>
//               <Card.Text as="h3" className="text-primary">
//                 KES {metrics.total_amount?.toLocaleString() || 0}
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 {metrics.total_invoices} invoices
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-danger">
//                 <i className="fas fa-exclamation-triangle me-2"></i>
//                 Overdue Amount
//               </Card.Title>
//               <Card.Text as="h3" className="text-danger">
//                 KES {metrics.overdue_amount?.toLocaleString() || 0}
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 {metrics.overdue_count} overdue invoices
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-warning">
//                 <i className="fas fa-clock me-2"></i>
//                 Avg. Days Overdue
//               </Card.Title>
//               <Card.Text as="h3" className="text-warning">
//                 {Math.round(metrics.avg_days_overdue) || 0} days
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 Average delay in payments
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-success">
//                 <i className="fas fa-percentage me-2"></i>
//                 Collection Rate
//               </Card.Title>
//               <Card.Text as="h3" className="text-success">
//                 {metrics.total_invoices > 0
//                   ? Math.round(((metrics.total_invoices - metrics.total_unpaid) / metrics.total_invoices) * 100)
//                   : 0
//                 }%
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 Successful collections
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Charts Row */}
//       <Row className="mb-4">
//         {/* Trend Line Chart */}
//         <Col md={8} className="mb-3">
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Receivables Trend Over Time</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '300px' }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <LineChart data={trendData.monthlyBreakdown}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <Tooltip
//                       formatter={(value) => [`KES ${value.toLocaleString()}`, 'Amount']}
//                     />
//                     <Legend />
//                     <Line
//                       type="monotone"
//                       dataKey="total"
//                       stroke="#8884d8"
//                       strokeWidth={2}
//                       dot={{ fill: '#8884d8', strokeWidth: 2, r: 4 }}
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Category Pie Chart */}
//         <Col md={4} className="mb-3">
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Receivables by Category</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '300px' }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <PieChart>
//                     <Pie
//                       data={categoryData}
//                       cx="50%"
//                       cy="50%"
//                       outerRadius={80}
//                       fill="#8884d8"
//                       dataKey="total_amount"
//                       nameKey="category"
//                       label={({ category, total_amount }) =>
//                         `${category}: KES ${total_amount.toLocaleString()}`
//                       }
//                     >
//                       {categoryData.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                       ))}
//                     </Pie>
//                     <Tooltip
//                       formatter={(value) => [`KES ${value.toLocaleString()}`, 'Amount']}
//                     />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Category Breakdown Bar Chart */}
//       <Row className="mb-4">
//         <Col md={12}>
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Category Breakdown</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '400px' }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <BarChart data={categoryData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="category" angle={-45} textAnchor="end" height={80} />
//                     <YAxis />
//                     <Tooltip
//                       formatter={(value) => [`KES ${value.toLocaleString()}`, 'Amount']}
//                     />
//                     <Legend />
//                     <Bar dataKey="total_amount" fill="#8884d8" name="Total Amount" />
//                     <Bar dataKey="overdue_amount" fill="#ff6b6b" name="Overdue Amount" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Refresh Button */}
//       <Row>
//         <Col className="text-center">
//           <Button variant="primary" onClick={loadAnalyticsData}>
//             <i className="fas fa-sync-alt me-2"></i>
//             Refresh Analytics
//           </Button>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default ReceivablesAnalytics;

// components/ReceivablesAnalytics.js
// import React, { useState, useEffect } from "react";
// import { Row, Col, Card, Button, Spinner, Alert } from "react-bootstrap";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Bar, Line, Doughnut } from 'react-chartjs-2';
// import config from "../config";

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const ReceivablesAnalytics = ({ dateRange, fetchData }) => {
//   const [metrics, setMetrics] = useState(null);
//   const [categoryData, setCategoryData] = useState([]);
//   const [trendData, setTrendData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
//   const apiUrl = config[environment].apiUrl;

//   const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FF6B6B'];

//   useEffect(() => {
//     loadAnalyticsData();
//   }, [dateRange]);

//   console.log(dateRange)

//   const loadAnalyticsData = async () => {
//     setLoading(true);
//     setError(null);
    
//     try {
//       // Fetch all analytics data in parallel
//       const [metricsRes, categoryRes, trendRes] = await Promise.all([
//         fetch(`/api/analytics/receivables-metrics?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`),
//         fetch(`/api/analytics/receivables-by-category?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`),
//         fetch(`/api/analytics/receivables-trend?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`)
//       ]);

//       if (!metricsRes.ok || !categoryRes.ok || !trendRes.ok) {
//         throw new Error('Failed to fetch analytics data');
//       }

//       const [metricsData, categoryData, trendData] = await Promise.all([
//         metricsRes.json(),
//         categoryRes.json(),
//         trendRes.json()
//       ]);

//       setMetrics(metricsData);
//       setCategoryData(categoryData);
//       setTrendData(trendData);
//     } catch (err) {
//       console.error("Error loading analytics:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Chart options configuration
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'top',
//       },
//       tooltip: {
//         callbacks: {
//           label: function(context) {
//             return `KES ${context.raw.toLocaleString()}`;
//           }
//         }
//       }
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function(value) {
//             return `KES ${value.toLocaleString()}`;
//           }
//         }
//       },
//       x: {
//         ticks: {
//           maxRotation: 45,
//           minRotation: 45
//         }
//       }
//     }
//   };

//   // Prepare chart data
//   const trendChartData = {
//     labels: trendData?.monthlyBreakdown?.map(item => item.month) || [],
//     datasets: [
//       {
//         label: 'Total Receivables',
//         data: trendData?.monthlyBreakdown?.map(item => item.total) || [],
//         borderColor: 'rgb(75, 192, 192)',
//         backgroundColor: 'rgba(75, 192, 192, 0.2)',
//         tension: 0.1,
//         fill: true,
//       }
//     ]
//   };

//   const categoryPieData = {
//     labels: categoryData.map(item => item.category) || [],
//     datasets: [
//       {
//         label: 'Amount by Category',
//         data: categoryData.map(item => item.total_amount) || [],
//         backgroundColor: COLORS,
//         borderColor: COLORS.map(color => color.replace('0.8', '1')),
//         borderWidth: 1,
//       }
//     ]
//   };

//   const categoryBarData = {
//     labels: categoryData.map(item => item.category) || [],
//     datasets: [
//       {
//         label: 'Total Amount',
//         data: categoryData.map(item => item.total_amount) || [],
//         backgroundColor: 'rgba(54, 162, 235, 0.8)',
//       },
//       {
//         label: 'Overdue Amount',
//         data: categoryData.map(item => item.overdue_amount) || [],
//         backgroundColor: 'rgba(255, 99, 132, 0.8)',
//       }
//     ]
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading analytics data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <Alert variant="danger">
//         <Alert.Heading>Error Loading Analytics</Alert.Heading>
//         <p>{error}</p>
//         <Button variant="outline-danger" onClick={loadAnalyticsData}>
//           Retry
//         </Button>
//       </Alert>
//     );
//   }

//   if (!metrics || !categoryData.length || !trendData) {
//     return (
//       <div className="text-center py-4">
//         <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
//         <h5>No analytics data available</h5>
//         <p className="text-muted">No receivables data found for the selected period.</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Key Metrics Row */}
//       <Row className="mb-4">
//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-primary">
//                 <i className="fas fa-receipt me-2"></i>
//                 Total Receivables
//               </Card.Title>
//               <Card.Text as="h3" className="text-primary">
//                 KES {metrics.total_amount?.toLocaleString() || 0}
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 {metrics.total_invoices} invoices
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-danger">
//                 <i className="fas fa-exclamation-triangle me-2"></i>
//                 Overdue Amount
//               </Card.Title>
//               <Card.Text as="h3" className="text-danger">
//                 KES {metrics.overdue_amount?.toLocaleString() || 0}
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 {metrics.overdue_count} overdue invoices
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-warning">
//                 <i className="fas fa-clock me-2"></i>
//                 Avg. Days Overdue
//               </Card.Title>
//               <Card.Text as="h3" className="text-warning">
//                 {Math.round(metrics.avg_days_overdue) || 0} days
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 Average delay in payments
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={3} className="mb-3">
//           <Card className="text-center h-100">
//             <Card.Body>
//               <Card.Title className="text-success">
//                 <i className="fas fa-percentage me-2"></i>
//                 Collection Rate
//               </Card.Title>
//               <Card.Text as="h3" className="text-success">
//                 {metrics.total_invoices > 0 
//                   ? Math.round(((metrics.total_invoices - metrics.total_unpaid) / metrics.total_invoices) * 100)
//                   : 0
//                 }%
//               </Card.Text>
//               <Card.Text as="small" className="text-muted">
//                 Successful collections
//               </Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Charts Row */}
//       <Row className="mb-4">
//         {/* Trend Line Chart */}
//         <Col md={8} className="mb-3">
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Receivables Trend Over Time</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '300px' }}>
//                 <Line 
//                   data={trendChartData} 
//                   options={chartOptions}
//                 />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Category Doughnut Chart */}
//         <Col md={4} className="mb-3">
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Receivables by Category</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '300px' }}>
//                 <Doughnut 
//                   data={categoryPieData} 
//                   options={{
//                     ...chartOptions,
//                     plugins: {
//                       ...chartOptions.plugins,
//                       tooltip: {
//                         callbacks: {
//                           label: function(context) {
//                             const label = context.label || '';
//                             const value = context.raw || 0;
//                             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                             const percentage = ((value / total) * 100).toFixed(1);
//                             return `${label}: KES ${value.toLocaleString()} (${percentage}%)`;
//                           }
//                         }
//                       }
//                     }
//                   }}
//                 />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Category Breakdown Bar Chart */}
//       <Row className="mb-4">
//         <Col md={12}>
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Category Breakdown</h6>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: '400px' }}>
//                 <Bar 
//                   data={categoryBarData} 
//                   options={{
//                     ...chartOptions,
//                     scales: {
//                       ...chartOptions.scales,
//                       x: {
//                         ticks: {
//                           maxRotation: 45,
//                           minRotation: 45
//                         }
//                       }
//                     }
//                   }}
//                 />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Additional Metrics Row */}
//       <Row className="mb-4">
//         <Col md={6}>
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Aging Analysis</h6>
//             </Card.Header>
//             <Card.Body>
//               <Row>
//                 <Col md={6}>
//                   <div className="text-center">
//                     <h5 className="text-info">
//                       <i className="fas fa-calendar-check me-2"></i>
//                       Current
//                     </h5>
//                     <h3 className="text-info">
//                       KES {((metrics.total_amount || 0) - (metrics.overdue_amount || 0)).toLocaleString()}
//                     </h3>
//                     <small className="text-muted">Not yet due</small>
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="text-center">
//                     <h5 className="text-danger">
//                       <i className="fas fa-calendar-times me-2"></i>
//                       Overdue
//                     </h5>
//                     <h3 className="text-danger">
//                       KES {(metrics.overdue_amount || 0).toLocaleString()}
//                     </h3>
//                     <small className="text-muted">Past due date</small>
//                   </div>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={6}>
//           <Card>
//             <Card.Header>
//               <h6 className="mb-0">Collection Performance</h6>
//             </Card.Header>
//             <Card.Body>
//               <Row>
//                 <Col md={6}>
//                   <div className="text-center">
//                     <h5 className="text-success">
//                       <i className="fas fa-check-circle me-2"></i>
//                       Collected
//                     </h5>
//                     <h3 className="text-success">
//                       {metrics.total_invoices > 0 ? Math.round(((metrics.total_invoices - metrics.total_unpaid) / metrics.total_invoices) * 100) : 0}%
//                     </h3>
//                     <small className="text-muted">Success rate</small>
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="text-center">
//                     <h5 className="text-warning">
//                       <i className="fas fa-clock me-2"></i>
//                       Pending
//                     </h5>
//                     <h3 className="text-warning">
//                       {metrics.total_unpaid || 0}
//                     </h3>
//                     <small className="text-muted">Outstanding invoices</small>
//                   </div>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Refresh Button */}
//       <Row>
//         <Col className="text-center">
//           <Button variant="primary" onClick={loadAnalyticsData}>
//             <i className="fas fa-sync-alt me-2"></i>
//             Refresh Analytics
//           </Button>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export {ReceivablesAnalytics};


// components/ReceivablesAnalytics.js
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Spinner, Alert, ProgressBar } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Line, Doughnut } from 'react-chartjs-2';
import config from "../config";
import { formatKES } from "../utils/currency";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const ReceivablesAnalytics = ({ dateRange, fetchData }) => {
  const [metrics, setMetrics] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [trendData, setTrendData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [receivablesData, setReceivablesData] = useState([]);
  
    useEffect(() => {
      fetchData("receivables", setReceivablesData);
    }, [dateRange, fetchData]);
  
  console.log(receivablesData, "RecievablesDataFrom")
  
   
const data = receivablesData


  useEffect(() => {
    loadAnalyticsData();
  }, [dateRange]);

  const loadAnalyticsData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const [metricsRes, categoryRes, trendRes] = await Promise.all([
        fetch(`/api/analytics/receivables-metrics?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`),
        fetch(`/api/analytics/receivables-by-category?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`),
        fetch(`/api/analytics/receivables-trend?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`)

      ]);

      if (!metricsRes.ok || !categoryRes.ok) {
        throw new Error('Failed to fetch analytics data');
      }

      const [metricsData, categoryData, trendData] = await Promise.all([
        metricsRes.json(),
        categoryRes.json(),
          trendRes.json()
      ]);

      setMetrics(metricsData);
      setCategoryData(categoryData);
       setTrendData(trendData);
    } catch (err) {
      console.error("Error loading analytics:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `KES ${context.raw.toLocaleString()}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { callback: (value) => `KES ${value.toLocaleString()}` }
      }
    }
  };

  const categoryChartData = {
    labels: categoryData.map(item => item.category),
    datasets: [
      {
        label: 'Total Amount',
        data: categoryData.map(item => item.total_amount),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
      {
        label: 'Paid Amount',
        data: categoryData.map(item => item.paid_amount),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Balance Amount',
        data: categoryData.map(item => item.balance_amount),
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
      }
    ]
  };

   // Prepare chart data
  const trendChartData = {
    labels: trendData?.monthlyBreakdown?.map(item => item.month) || [],
    datasets: [
      {
        label: 'Total Receivables',
        data: trendData?.monthlyBreakdown?.map(item => item.total) || [],
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        tension: 0.1,
        fill: true,
      }
    ]
  };
 

 if (!receivablesData || receivablesData.length === 0) {
    return (
      <div className="text-center py-4">No receivables data available</div>
    );
  }

  if (!data) return <p>Loading...</p>;
  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorAlert error={error} onRetry={loadAnalyticsData} />;
  if (!metrics) return <NoDataMessage />;

  
  
    const barData = {
    labels: Object.keys(data.breakdown.byStakeholder),
    datasets: [
      {
        label: "Balance",
        data: Object.values(data.breakdown.byStakeholder).map(s => s.balance),
        backgroundColor: "#e74a3b",
      },
      {
        label: "Paid",
        data: Object.values(data.breakdown.byStakeholder).map(s => s.paid),
        backgroundColor: "#1cc88a",
      },
    ],
  };


  return (
    <div>
      {/* Key Metrics Row */}
      <Row className="mb-4">
        <Col md={3} className="mb-3">
          <MetricCard
            title="Total Receivables"
            value={metrics.total_amount}
            subValue={`${metrics.total_invoices} invoices`}
            icon="fas fa-receipt"
            color="primary"
          />
        </Col>
        <Col md={3} className="mb-3">
          <MetricCard
            title="Amount Paid"
            value={metrics.total_paid}
            subValue={`${Math.round((metrics.total_paid / metrics.total_amount) * 100)}% collected`}
            icon="fas fa-check-circle"
            color="success"
          />
        </Col>
        <Col md={3} className="mb-3">
          <MetricCard
            title="Balance Due"
            value={metrics.total_balance}
            subValue={`${metrics.overdue_count} overdue`}
            icon="fas fa-clock"
            color="warning"
          />
        </Col>
        <Col md={3} className="mb-3">
          <MetricCard
            title="Overdue Amount"
            value={metrics.overdue_amount}
            subValue={`${Math.round(metrics.avg_days_overdue)} days avg. delay`}
            icon="fas fa-exclamation-triangle"
            color="danger"
          />
        </Col>
      </Row>

      {/* Progress Bar */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Collection Progress</h6>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between mb-2">
                <span>Collection Rate</span>
                <span>{Math.round((metrics.total_paid / metrics.total_amount) * 100)}%</span>
              </div>
              <ProgressBar now={(metrics.total_paid / metrics.total_amount) * 100} 
                variant="success" 
                className="mb-3"
                style={{ height: '20px' }}
              />
              <Row>
                <Col md={4}>
                  <div className="text-center">
                    <h6 className="text-success">KES {metrics.total_paid?.toLocaleString()}</h6>
                    <small className="text-muted">Amount Collected</small>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <h6 className="text-warning">KES {metrics.total_balance?.toLocaleString()}</h6>
                    <small className="text-muted">Balance Due</small>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <h6 className="text-danger">KES {metrics.overdue_amount?.toLocaleString()}</h6>
                    <small className="text-muted">Overdue</small>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Category Breakdown */}
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Header>
              <h6 className="mb-0">Receivables by Category</h6>
            </Card.Header>
            <Card.Body>
              <div style={{ height: '400px' }}>
                <Bar data={categoryChartData} options={chartOptions} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Refresh Button */}
      <Row>
         <Col md={6} className="mb-3">
          <Card>
             <h5>Receivables Trend Over Time</h5>
              <div style={{ height: '300px' }}>
                <Line 
                  data={trendChartData} 
                  options={chartOptions}
                />
              </div>
          </Card>
        </Col>

        <Col md={6}>
                  <Card>
                    <h5>Receivables by Stakeholder</h5>
                    <Bar data={barData} />
                  </Card>
                </Col>

        {/* <Col className="text-center">
          <Button variant="primary" onClick={loadAnalyticsData}>
            <i className="fas fa-sync-alt me-2"></i>
            Refresh Analytics
          </Button>
        </Col> */}
      </Row>
    </div>
  );
};

const LoadingSpinner = () => (
  <div className="text-center py-5">
    <Spinner animation="border" variant="primary" />
    <p className="mt-2">Loading analytics data...</p>
  </div>
);

const ErrorAlert = ({ error, onRetry }) => (
  <Alert variant="danger">
    <Alert.Heading>Error Loading Analytics</Alert.Heading>
    <p>{error}</p>
    <Button variant="outline-danger" onClick={onRetry}>Retry</Button>
  </Alert>
);

const NoDataMessage = ({ type = "receivables" }) => (
  <div className="text-center py-4">
    <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
    <h5>No {type} data available</h5>
    <p className="text-muted">No {type} data found for the selected period.</p>
  </div>
);

const MetricCard = ({ title, value, subValue, icon, color }) => (
  <Card className={`text-center border-${color}`}>
    <Card.Body>
      <div className={`text-${color} mb-2`}>
        <i className={`${icon} fa-2x`}></i>
      </div>
      <h5 className={`text-${color}`}>
        {formatKES(value) || 0}
      </h5>
      <p className="text-muted mb-0">{title}</p>
      {subValue && <small className="text-muted">{subValue}</small>}
    </Card.Body>
  </Card>
);

export { ReceivablesAnalytics };